import { render, staticRenderFns } from "./MReportIssueButton.vue?vue&type=template&id=a07ff742&lang=pug&"
import script from "./MReportIssueButton.vue?vue&type=script&lang=js&"
export * from "./MReportIssueButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports